import React from "react";
import "./style.css";
import {
  FaGithub,
  FaLinkedin,
} from "react-icons/fa";
import { SiCodechef, SiCodeforces, SiLeetcode } from "react-icons/si";
import { socialprofils } from "../../content_option";

export const Socialicons = (params) => {
  return (
    <div className="stick_follow_icon">
      <ul>
        {socialprofils.github && (
          <li>
            <a href={socialprofils.github} target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </a>
          </li>
        )}
        {socialprofils.linkedin && (
          <li>
            <a href={socialprofils.linkedin} target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
          </li>
        )}
        {socialprofils.codechef && (
          <li>
            <a href={socialprofils.codechef} target="_blank" rel="noopener noreferrer">
              <SiCodechef />
            </a>
          </li>
        )}
        {socialprofils.leetcode && (
          <li>
            <a href={socialprofils.leetcode} target="_blank" rel="noopener noreferrer">
              <SiLeetcode />
            </a>
          </li>
        )}
        {socialprofils.codeforces && (
          <li>
            <a href={socialprofils.codeforces} target="_blank" rel="noopener noreferrer">
              <SiCodeforces />
            </a>
          </li>
        )}
      </ul>
      <p>Follow Me</p>
    </div>
  );
};
